// Detects whether the app is running inside a native Capacitor WebView.
// Works before @capacitor/core is installed (falls back to a scheme sniff);
// once Capacitor is present, its own isNativePlatform() is authoritative.
export const isNativePlatform = (): boolean => {
  if (typeof window === 'undefined') return false;
  const w = window as any;
  if (w.Capacitor && typeof w.Capacitor.isNativePlatform === 'function') {
    return w.Capacitor.isNativePlatform();
  }
  const protocol = window.location.protocol;
  return protocol === 'capacitor:' || protocol === 'ionic:' || protocol === 'file:';
};
